import { useTheme } from "@fluentui/react";
import { createDarkTheme, createHighContrastTheme, createLightTheme } from "@fluentui/react-components";
import { PlannerTheme } from "@ms/uno-constants/lib/local/ThemeConstants";
// From https://www.figma.com/file/uv88aMSwM6VVaJn08JKXhv/%F0%9F%93%9A-UNO-Component-Library?type=design&node-id=612%3A85811&mode=design&t=mPVSKvtKw6HIDY3T-1
export const brandUno = {
    10: "#2B2B40",
    20: "#2F2F4A",
    30: "#333357",
    40: "#383966",
    50: "#3D3E78",
    60: "#444791",
    70: "#4F52B2",
    80: "#5B5FC7",
    90: "#7579EB",
    100: "#7F85F5",
    110: "#9299F7",
    120: "#AAB1FA",
    130: "#B6BCFA",
    140: "#C5CBFA",
    150: "#DCDFFA",
    160: "#E8EBFA"
};
/** Light theme for Uno as derived from design's brand variant colors */ const unoLightTheme = createLightTheme(brandUno);
/** Dark theme for Uno as derived from design's brand variant colors */ const unoDarkTheme = createDarkTheme(brandUno);
/** High contrast theme for FluentUI V9, for use in the Copilot pane */ const highContrastTheme = createHighContrastTheme();
/**
 * Convert V8 Uno theme name to V9 Uno theme
 */ export const useUnoTheme = ()=>{
    const theme = useTheme();
    return useV9Theme(theme.name);
};
/**
 * Creates and loads the v9 theme for the FluentProvider, based on the provided Uno theme
 * @param unoTheme The Uno theme
 */ export const useV9Theme = (unoTheme)=>{
    switch(unoTheme){
        case PlannerTheme.Dark:
            return unoDarkTheme;
        case PlannerTheme.HighContrast:
            return highContrastTheme;
        case PlannerTheme.Light:
        default:
            return unoLightTheme;
    }
};
